import { extractCookie } from './links';
import { useTranslationStore } from '@/stores/translationStore';

export default function getLocale(cookies) {
  const translationStore = useTranslationStore();
  const lang = translationStore.getLanguage;
  return lang || extractCookie(cookies, 'langCode', 'en');
}
